import { createLucideIcon } from 'lucide-react';

// Lucide has no three-person glyph. Same 24px grid and 2px stroke as its
// `users` icon: one person in front, two smaller ones behind on either side.
export const UsersThree = createLucideIcon('users-three', [
  ['circle', { cx: '12', cy: '9', r: '3', key: 'center-head' }],
  ['path', { d: 'M6.5 21v-.5A4.5 4.5 0 0 1 11 16h2a4.5 4.5 0 0 1 4.5 4.5v.5', key: 'center-body' }],
  ['circle', { cx: '5', cy: '6.5', r: '2', key: 'left-head' }],
  ['path', { d: 'M1.5 16.5v-.5a3 3 0 0 1 3-3h2', key: 'left-body' }],
  ['circle', { cx: '19', cy: '6.5', r: '2', key: 'right-head' }],
  ['path', { d: 'M22.5 16.5v-.5a3 3 0 0 0-3-3h-2', key: 'right-body' }],
]);
